var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17106_264542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3849 13.4414C15.7131 13.7265 15.7208 14.2334 15.4014 14.5283L12.2854 17.4055C11.9169 17.7458 11.3533 17.7604 10.9676 17.4397L9.61311 16.3135C9.28202 16.0382 9.2545 15.5397 9.55329 15.2296C9.83298 14.9394 10.2934 14.9259 10.5895 15.1994L11.6415 16.1707L14.3958 13.4712C14.6674 13.2051 15.0978 13.1921 15.3849 13.4414Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0344 7.71564L14.7844 2.46564C14.6415 2.32635 14.4495 2.24889 14.25 2.25001H5.25C4.85218 2.25001 4.47064 2.40805 4.18934 2.68935C3.90804 2.97066 3.75 3.35219 3.75 3.75001V20.25C3.75 20.6478 3.90804 21.0294 4.18934 21.3107C4.47064 21.592 4.85218 21.75 5.25 21.75H18.75C19.1478 21.75 19.5294 21.592 19.8107 21.3107C20.092 21.0294 20.25 20.6478 20.25 20.25V8.25001C20.2511 8.05048 20.1737 7.85851 20.0344 7.71564ZM15 4.80939L17.6906 7.50001H15V4.80939ZM18.75 20.25H5.25V3.75001H13.5V8.25001C13.5 8.44892 13.579 8.63969 13.7197 8.78034C13.8603 8.92099 14.0511 9.00001 14.25 9.00001H18.75V20.25Z",
    fill: "#4CAF50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17106_264542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocOk);
export default __webpack_public_path__ + "static/media/doc-ok.a462636c8918c7fcdaf9e3c2e7e461c9.svg";
export { ForwardRef as ReactComponent };